import "./top-bar.scss";

import React from "react";
import { Link } from "gatsby";

const TopBar = ({ onSearchClick }) => {
  return (
    <div className="top-bar">
      <Link to="/kontakt/#o-nas" className="top-bar__link">
        O nas
      </Link>
      <Link to="/kariera" className="top-bar__link">
        Kariera
      </Link>
      <button
        type="button"
        className="top-bar__search-btn"
        onClick={onSearchClick}
      >
        <img
          src={require("assets/icons/search.svg").default}
          alt=""
          className="top-bar__search-icon"
        />
      </button>
    </div>
  );
};

export default TopBar;
